// lib files
import { ContentServiceVideoObject } from '@/lib/types/api/content-service';
import { normalizeVideoData } from '@/lib/helpers/normalize-video-data';

// components
import MyListViewingHistoryGridItem from '@/components/MyList/MyListViewingHistory/MyListViewingHistoryGridItem';

// styles
import styles from './MyListViewingHistoryGrid.module.scss';

interface MyListViewingHistoryGridProps {
  videos: ContentServiceVideoObject[];
}

const MyListViewingHistoryGrid = (props: MyListViewingHistoryGridProps) => {
  const { videos } = props;

  const processedVideos = videos.map((video) => {
    return normalizeVideoData(video);
  });

  return (
    <div className={styles.my_list_viewing_history_grid}>
      {processedVideos.map((video, i: number) => {
        return (
          <MyListViewingHistoryGridItem video={video} key={i} />
        )
      })}
    </div>
  );
};

export default MyListViewingHistoryGrid;
